<template>
  <div>
    <h2>{{ $t('title.access-schemes') }}</h2>

    <base-list
      model="access-schemes"
      :columns="['name']"
      s-model="access-scheme"
      />
  </div>

</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'access-scheme-list',
  components: { BaseList }
}
</script>


// WEBPACK FOOTER //
// AccessSchemeList.vue?76272858